module.exports = __webpack_public_path__ + "img/shared_group_check.1b760990.svg";